import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'rejectionReason',
    standalone: false
})
export class RejectionReasonPipe implements PipeTransform {
    static result;

    constructor(private http: HttpClient) {
    }

    transform(id): any {
        if (RejectionReasonPipe.result != null) {
            return new Observable(obs => {
                obs.next(this.get(id));
                obs.complete();
            });
        }
        return this.http.get<any>('/VerificationRequestRejectionReasons/page/0')
            .pipe(map(a => {
                RejectionReasonPipe.result = a.items;
                return this.get(id);
            }));
    }

    get(id) {
        return RejectionReasonPipe.result.filter(a => a.id === id)[0]?.name;
    }
}
